import type { UserType, OrganisationDto, ParcelShop as ServicePointDto } from '@dhl/mdp-api'
import { OrganisationInfo } from '~/modules/users/model'

export const getOrganisationInfo = (
  servicePointDto?: ServicePointDto,
  organisationDto?: OrganisationDto,
  terminalDto?: OrganisationDto
): OrganisationInfo => {
  if (servicePointDto) {
    return {
      parcelShopName: servicePointDto.name,
    }
  } else if (organisationDto) {
    return {
      organisationType: 'organisation',
      organisationName: organisationDto.name,
      organisationBusinessUnitCode: organisationDto.businessUnitCode,
    }
  } else if (terminalDto) {
    return {
      organisationType: 'terminal',
      organisationName: terminalDto.name,
      organisationBusinessUnitCode: terminalDto.businessUnitCode,
    }
  } else {
    return {}
  }
}

export const getOrganisationUrl = (userType?: UserType) => {
  switch (userType) {
    case 'terminal':
      return 'terminal'
    case 'business':
      return 'organisation'
    case 'parcelShop':
      return 'parcel-shops'
    default:
      return ''
  }
}
